import React, { useState, useEffect } from "react";
import { Row, Col, Button, Spinner } from "react-bootstrap";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import _ from "lodash";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SwalMessage from "../_Components/SwalMessage";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import ApiAgentCommission from "../../../core/api/api.agentCommission";
import ApiAmusementService from "../../../core/api/api.amusementService";
import "./style.css";
import HTMLInput from "../_Components/HTMLInput";
const EditAgentCommissionItems = () => {
  const location = useLocation();
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search);
  const ourDefaultParam = searchParams.get("ourDefault");
  const [agentCommissionItem, setAgentCommissionItem] = useState();
  const [amusementServices, setAmusementServices] = useState([]);
  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
    getValues,
    setValue,
  } = useForm();
  let { id } = useParams();

  const formatNumber = (value) => {
    const stringValue = String(value);
    return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleChange = (event, service, item, typeName) => {
    const elementName = `${service.id}${typeName}${item.id}`
    const numberValue = event.target.value.replace(/[^0-9]/g, "");
    setValue(elementName, formatNumber(numberValue));
    // use the below function to change other fields
    let splitElmenet = elementName.split(typeName);
    calculateOtherInputFields(splitElmenet[0], splitElmenet[1], typeName);
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await ApiAgentCommission.getAgentCommissionById({ id });
        if (response.succeeded) {
          setAgentCommissionItem(response.data);
          const supplierId = response.data?.supplierId;
          const allAmusementServices = await ApiAmusementService.getAllAmusementServiceBySupplierId({ supplierId });
          setAmusementServices(allAmusementServices);
          setFormStateValues(response.data, allAmusementServices);
        }
        else {
          SwalMessage({ title: response?.message, iSsuccess: false });
        }
      } catch (error) {
      }
    })();
  }, []);

  const calculateOtherInputFields = (service, item, fieldType) => {
    const saleRateValue = +getValues(`${service.id}saleRate${item.id}`).replaceAll(",", "");
    const key = `${service.id}${fieldType}${item.id}`;
    const inputValue =
      fieldType === "commissionPercentage" || fieldType == "defaultCommissionPercentage"
        ? +getValues(key)
        : +getValues(key).replaceAll(",", "");
    let commissionAmount, commissionPercentage, agentPaidAmount, defaultCommissionPercentage, defaultAgentPaidAmount, defaultCommissionAmount;

    switch (fieldType) {
      case "commissionPercentage":
        if (inputValue <= 100) {
          commissionPercentage = inputValue;
          commissionAmount = (saleRateValue * inputValue) / 100;
          agentPaidAmount = (saleRateValue - commissionAmount) + Math.trunc(saleRateValue * 0.1);
        }
        break;
      case "defaultCommissionPercentage":
        if (inputValue <= 100) {
          commissionPercentage = getValues(`${service.id}commissionPercentage${item.id}`) || 0;
          commissionAmount = (saleRateValue * commissionPercentage) / 100;
          agentPaidAmount = (saleRateValue - commissionAmount) + Math.trunc(saleRateValue * 0.1);
          defaultCommissionPercentage = inputValue;
          defaultCommissionAmount = defaultCommissionPercentage * (saleRateValue - item.supplierSettlementPrice) / 100;
          defaultAgentPaidAmount = saleRateValue - defaultCommissionAmount;
        }
        break;

      case "commissionAmount":
        if (inputValue <= saleRateValue) {
          commissionAmount = inputValue;
          commissionPercentage = ((inputValue / saleRateValue) * 100).toFixed();
          agentPaidAmount = (saleRateValue - commissionAmount) + Math.trunc(saleRateValue * 0.1);
        }
        break;

      case "agentPaidAmount":
        if (inputValue <= saleRateValue) {
          agentPaidAmount = inputValue;
          commissionAmount = saleRateValue - inputValue;
          commissionPercentage = ((commissionAmount / saleRateValue) * 100).toFixed();
        }
        break;
    }
    // ست کردن فرم
    setValue(`${service.id}defaultCommissionPercentage${item.id}`, defaultCommissionPercentage);
    setValue(`${service.id}defaultCommissionAmount${item.id}`, formatNumber(defaultCommissionAmount));
    setValue(`${service.id}defaultAgentPaidAmount${item.id}`, formatNumber(defaultAgentPaidAmount));
    setValue(`${service.id}commissionPercentage${item.id}`, commissionPercentage);
    setValue(`${service.id}commissionAmount${item.id}`, formatNumber(commissionAmount));
    setValue(`${service.id}agentPaidAmount${item.id}`, formatNumber(agentPaidAmount));
  };

  const setFormStateValues = (data, allAmusementServices) => {
    //   پر کردن نرخ فروش  برای همه آیتم‌ها
    allAmusementServices.forEach(({ id, amusementServiceReserveItems }) => {
      amusementServiceReserveItems.forEach((item) => {
        setValue(`${id}saleRate${item.id}`, formatNumber(+item.price));
      });
    });

    //    اگر جیسون وجود دارد، سایر مقادیر را با آن پر کن
    if (data.amusementServiceReserveItemCommissionJson) {
      const parsedJson = JSON.parse(data.amusementServiceReserveItemCommissionJson);
      parsedJson.forEach((item) => {
        const amusementServiceId = item.amusementServiceId;
        const currentService = allAmusementServices.find((s) => s.id === amusementServiceId);

        item.commissions.forEach((i) => {
          const amusementServiceReserveItemId = i.amusementServiceReserveItemId;
          const defaultCommissionPercentage = +i.defaultCommissionPercentage || 0;

          const commissionPercentage = +i.commissionPercentage || 0;
          const commissionAmount = +i.commissionAmount || 0;

          const currentItem = currentService?.amusementServiceReserveItems?.find(
            (ai) => ai.id == amusementServiceReserveItemId
          );
          const saleRateValue = currentItem ? +currentItem.price : 0;

          // محاسبه مبلغ پرداختی آژانس
          const agentPaidAmount =
            (saleRateValue - commissionAmount) + Math.trunc(saleRateValue * 0.1);

          const defaultCommissionAmount = defaultCommissionPercentage * (+saleRateValue - +currentItem?.supplierSettlementPrice) / 100;

          // محاسبه مبلغ پرداختی آژانس
          const defaultAgentPaidAmount = saleRateValue - defaultCommissionAmount

          // ست کردن مقادیر
          setValue(
            `${amusementServiceId}commissionPercentage${amusementServiceReserveItemId}`,
            commissionPercentage || 0
          );
          setValue(
            `${amusementServiceId}commissionAmount${amusementServiceReserveItemId}`,
            formatNumber(commissionAmount)
          );
          setValue(
            `${amusementServiceId}agentPaidAmount${amusementServiceReserveItemId}`,
            formatNumber(agentPaidAmount)
          );
          setValue(`${amusementServiceId}defaultCommissionPercentage${amusementServiceReserveItemId}`, defaultCommissionPercentage || 0)

          setValue(
            `${amusementServiceId}defaultAgentPaidAmount${amusementServiceReserveItemId}`,
            formatNumber(defaultAgentPaidAmount)
          );
          setValue(
            `${amusementServiceId}defaultCommissionAmount${amusementServiceReserveItemId}`,
            formatNumber(defaultCommissionAmount)
          );
        });
      });
    }
  };



  const transformFormData = (formState) => {
    const result = {};

    Object.keys(formState).forEach((key) => {
      // Extract the amusementServiceId, field type, and amusementServiceReserveItemId from the key
      const inputValue = getValues(key);
      if (inputValue && !_.isUndefined(inputValue)) {
        const match = key.match(
          /^(\d+)(commissionPercentage|commissionAmount|agentPaidAmount|defaultCommissionPercentage)(\d+)$/
        );
        if (match) {
          const amusementServiceId = parseInt(match[1]);
          const fieldType = match[2]; // Either "commissionPercentage" or "commissionAmount" or "agentPaidAmount"
          const amusementServiceReserveItemId = parseInt(match[3]);
          const value = parseFloat(
            _.isNumber(formState[key])
              ? formState[key]
              : formState[key].replaceAll(",", "")
          );
          // Initialize the amusementServiceId group if it doesn't exist
          if (!result[amusementServiceId]) {
            result[amusementServiceId] = {
              amusementServiceId,
              commissions: [],
            };
          }

          // Find or create the commission entry for the amusementServiceReserveItemId
          let commission = result[amusementServiceId].commissions.find(
            (entry) =>
              entry.amusementServiceReserveItemId ==
              amusementServiceReserveItemId
          );
          if (!commission) {
            commission = { amusementServiceReserveItemId };
            result[amusementServiceId].commissions.push(commission);
          }
          // Add the field value to the commission
          commission[fieldType] = value;
        }
      }
    });

    // Convert the grouped object to an array
    return Object.values(result);
  };

  const onSubmit = async (data) => {
    try {
      // Transform the form state
      const transformedData = transformFormData(data);
      const stringified = JSON.stringify(transformedData);
      const dataToSendServer = {
        AmusementServiceReserveItemCommissionJson: stringified,
        AgentCommissionId: +id,
      };
      let response = await ApiAgentCommission.editAgentCommissionItems(dataToSendServer);
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      if (response.succeeded) {
        navigate("/agentCommissions");
      }
    } catch (error) {
    }
  };

  return (
    <>
      <div>
        <div className={`card card-custom`}>
          {/* Start Box Header */}
          <div className="card-header border-0 pb-3 pt-5">
            <h3 className="card-title align-items-start flex-column">
              <span className="card-label font-weight-bolder text-dark">
                گروه کمیسیون "{agentCommissionItem?.name}" {ourDefaultParam && "تفریحان"}
              </span>
              <span className="text-muted mt-3 font-weight-bold font-size-sm">
                افزودن یا ویرایش آیتم های گروه کمیسیون "
                {agentCommissionItem?.name}" {ourDefaultParam && "تفریحان"}
                <br />
                تامین کننده: {agentCommissionItem?.supplierCompanyName}
              </span>
            </h3>
          </div>
          {/*Start body */}
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="card-body pt-3 pb-0 border-top">
              <Row className="mt-3">
                <Col>
                  <Button
                    variant="success"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting && (
                      <Spinner animation="border" variant="warning" size="sm" />
                    )}
                    <SaveIcon /> ذخیره
                  </Button>
                  <Link className="btn btn-danger ml-3" to="/agentCommissions">
                    <CloseIcon /> بازگشت
                  </Link>
                </Col>
              </Row>
              <Row className="mt-3">
                {amusementServices?.map((service) => {
                  return (
                    <>
                      {service.amusementServiceReserveItems.length != 0 && <Col xs="12" className="mt-3 ">
                        <Accordion key={service.id} className="border">
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`panel${service.id}-content`}
                            id={`panel${service.id}-header`}
                          >
                            <div>{service.name}</div>
                          </AccordionSummary>
                          <AccordionDetails>
                            {service.amusementServiceReserveItems?.map(
                              (item, itemIndex) => (
                                <div
                                  key={`${service.serviceId}-${item.id}`}
                                  style={{ marginBottom: "1rem" }}
                                >
                                  <h3 className="pb-3">{item.title}</h3>
                                  <Row className="py-4">
                                    <Col xs="12" sm="6" md className="mb-5 mb-lg-0">
                                      <HTMLInput
                                        label="نرخ فروش"
                                        className="form-control"
                                        placeholder="نرخ فروش"
                                        registeredParams={{
                                          ...register(
                                            `${service.id}saleRate${item.id}`
                                          )
                                        }}
                                        placeholder="نرخ مصوب"
                                        readOnly
                                        disabled
                                      />
                                    </Col>
                                    <Col xs="12" sm="6" md className="mb-5 mb-lg-0">
                                      <HTMLInput
                                        label="درصد کمیسیون"
                                        className="form-control"
                                        placeholder="درصد کمیسیون"
                                        registeredParams={{
                                          ...register(
                                            ourDefaultParam ? `${service.id}defaultCommissionPercentage${item.id}` : `${service.id}commissionPercentage${item.id}`,
                                            {
                                              max: {
                                                value: 100,
                                              },
                                              min: {
                                                value: 0,
                                              },
                                            }
                                          )
                                        }}
                                        onInput={(e) => {
                                          if (e.target.value > 100) {
                                            e.target.value = 100; // Limit the value to 100
                                          }
                                        }}
                                        onChange={(e) => {
                                          register(
                                            ourDefaultParam ? `${service.id}defaultCommissionPercentage${item.id}` : `${service.id}commissionPercentage${item.id}`,
                                          ).onChange(e);
                                          calculateOtherInputFields(
                                            service,
                                            item,
                                            ourDefaultParam ? "defaultCommissionPercentage" : "commissionPercentage"
                                          );
                                        }}
                                      />
                                    </Col>
                                    <Col xs="12" sm="6" md className="mb-5 mb-lg-0">
                                      <HTMLInput
                                        label="مبلغ کمیسیون"
                                        className="form-control"
                                        placeholder="مبلغ کمیسیون"
                                        registeredParams={{
                                          ...register(
                                            ourDefaultParam ? `${service.id}defaultCommissionAmount${item.id}` : `${service.id}commissionAmount${item.id}`
                                          )
                                        }}
                                        onChange={(e) =>
                                          handleChange(
                                            e,
                                            service,
                                            item,
                                            ourDefaultParam ? "defaultCommissionAmount" : "commissionAmount"
                                          )
                                        }
                                        disabled={ourDefaultParam}
                                      />
                                    </Col>

                                    <Col xs="12" sm="6" md className="mb-5 mb-lg-0">
                                      <HTMLInput
                                        label="مبلغ پرداختی آژانس"
                                        placeholder="مبلغ پرداختی آژانس"
                                        registeredParams={{ ...register(ourDefaultParam ? `${service.id}defaultAgentPaidAmount${item.id}` : `${service.id}agentPaidAmount${item.id}`) }}
                                        placeholder="نرخ مصوب"
                                        className="form-control"
                                        readOnly
                                        disabled
                                      />
                                    </Col>
                                  </Row>
                                </div>
                              )
                            )}
                          </AccordionDetails>
                        </Accordion>
                      </Col>}
                    </>

                  )
                })}
              </Row>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

//let pricediscount =[];
// let pricediscountCommision = [];
// let percentdiscount =[];
// let percentdiscountCommision = [];
// let objData = [];
// const lastItemId = null
// const lastServiceItemId = null
// Object.keys(data).map((item) => {
//   const inputValue = getValues(item);
//   if (!_.isEmpty(inputValue) && !_.isUndefined(inputValue)) {
//     let split = [];
//     ////////////////////////////////////////////////////////////
//     // if (item.indexOf("commissionPercentage") != -1 || item.indexOf("commissionAmount") != -1 || item.indexOf("agentPaidAmount") != -1) {
//     if (!item.includes("saleRate")) {

//       if (item.indexOf("commissionPercentage") != -1) {
//         split = item.split("commissionPercentage");
//         // pricediscountCommision.push({ serviceId: split[0], serviceItemId: split[1] });
//       } else if (item.indexOf("commissionAmount") != -1) {
//         split = item.split("commissionAmount");
//         // percentdiscountCommision.push({ serviceId: split[0], serviceItemId: split[1] });
//       } else {
//         split = item.split("agentPaidAmount");

//       }

////////////////////////////////////////////////////////////
// let resITem = objData?.find((item) => item.amusementServiceId == split[0]);

// if (_.isUndefined(resITem)) {
//   objData.push({
//     amusementServiceId: split[0],
//     amusementServiceFormFieldIds: [
//       {
//         id: split[1],
//         discountpriceCommision: item.indexOf("pricediscountCommision") != -1 ? inputValue : 0,
//         discountPricePercentCommision: item.indexOf("percentdiscountCommision") != -1 ? inputValue : 0,
//       },
//     ],
//     PromoCategoryCommisionId: id,
//   });
// } else {
//   let objamusService = resITem.amusementServiceFormFieldIds.find((item) => item.id == split[1]);
//   if (_.isUndefined(objamusService)) {
//     resITem.amusementServiceFormFieldIds.push({
//       id: split[1],
//       discountpriceCommision: item.indexOf("pricediscountCommision") != -1 ? inputValue : 0,
//       discountPricePercentCommision: item.indexOf("percentdiscountCommision") != -1 ? inputValue : 0,
//     });
//   } else {
//     if (item.indexOf("pricediscountCommision") != -1) objamusService.discountpriceCommision = inputValue;
//     else if (item.indexOf("percentdiscountCommision") != -1)
//       objamusService.discountPricePercentCommision = inputValue;
//   }
// }
//     }
//   }
// });
// let tt = objData?.map((item) => {
//   return (item.amusementServiceFormFieldIds = JSON.stringify(item.amusementServiceFormFieldIds));
// });

export default EditAgentCommissionItems;
